module.exports = __webpack_public_path__ + "static/media/innocent-thumbnail.a8bfe374.png";